export default "__VITE_ASSET__Dwf$_b3N__"